<label class="block text-xs text-gray-900 my-1">
    {{text}}
</label>